export default __webpack_public_path__ + "afa84f8c633b47dd5fa1a2b3b41e8baa.jpg";